(function () {
  'use strict';

  var CARET_SVG =
    '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 ' +
    '1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">' +
    '</svg>';

  var sortedItems = [];
  var isSorting = false;
  var sortRequestId = 0;
  var resortTimer = null;

  // ─────────────────────────────────────────────
  // Config helpers
  // ─────────────────────────────────────────────

  function getConfig() {
    var el = document.getElementById('collection-sort-config');
    if (!el) return null;
    return {
      collectionUrl: el.dataset.collectionUrl,
      totalPages: parseInt(el.dataset.totalPages, 10) || 1,
      perPage: parseInt(el.dataset.productsPerPage, 10) || 24,
      sectionId: el.dataset.sectionId,
    };
  }

  function getCurrentUrlPage() {
    return Math.max(1, parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10));
  }

  function isAvailable(li) {
    return li.dataset.available === 'true';
  }

  function isNew(li) {
    return li.dataset.new === 'true';
  }

  // ─────────────────────────────────────────────
  // Fetch helpers
  // ─────────────────────────────────────────────

  function fetchPageItems(cfg, page) {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.set('page', page);
    params.set('sections', cfg.sectionId);
    var url = cfg.collectionUrl + '?' + params.toString();

    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (json) {
        var html = json[cfg.sectionId] || Object.values(json)[0] || '';
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.from(doc.querySelectorAll('#product-grid > li'));
      })
      .catch(function () { return []; });
  }

  function fetchAllItems(cfg) {
    var pages = [];
    for (var p = 1; p <= cfg.totalPages; p++) pages.push(p);
    return Promise.all(pages.map(function (p) { return fetchPageItems(cfg, p); }))
      .then(function (results) {
        return results.reduce(function (acc, b) { return acc.concat(b); }, []);
      });
  }

  // ─────────────────────────────────────────────
  // Pagination rendering
  // ─────────────────────────────────────────────

  function paginationParts(current, total) {
    if (total <= 7) {
      var all = [];
      for (var i = 1; i <= total; i++) all.push(i);
      return all;
    }
    var show = {};
    [1, 2, current - 1, current, current + 1, total - 1, total].forEach(function (n) {
      if (n >= 1 && n <= total) show[n] = true;
    });
    var keys = Object.keys(show).map(Number).sort(function (a, b) { return a - b; });
    var parts = [];
    var prev = null;
    keys.forEach(function (n) {
      if (prev !== null && n - prev > 1) parts.push(null); // ellipsis
      parts.push(n);
      prev = n;
    });
    return parts;
  }

  function renderPagination(totalItems, currentPage, perPage) {
    var totalPages = Math.ceil(totalItems / perPage);

    // Hide Shopify's native pagination
    var native = document.querySelector('#ProductGridContainer .pagination-wrapper');
    if (native) native.style.display = 'none';

    var existing = document.getElementById('js-av-pagination');

    if (totalPages <= 1) {
      if (existing) existing.remove();
      return;
    }

    var parts = paginationParts(currentPage, totalPages);
    var li = '';

    if (currentPage > 1) {
      li += '<li><button type="button" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce js-av-page" data-page="' + (currentPage - 1) + '" aria-label="前のページ">' + CARET_SVG + '</button></li>';
    }

    parts.forEach(function (p) {
      if (p === null) {
        li += '<li><span class="pagination__item">…</span></li>';
      } else if (p === currentPage) {
        li += '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="' + p + 'ページ目">' + p + '</a></li>';
      } else {
        li += '<li><button type="button" class="pagination__item link js-av-page" data-page="' + p + '" aria-label="' + p + 'ページ目">' + p + '</button></li>';
      }
    });

    if (currentPage < totalPages) {
      li += '<li><button type="button" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce js-av-page" data-page="' + (currentPage + 1) + '" aria-label="次のページ">' + CARET_SVG + '</button></li>';
    }

    var wrapper = existing || document.createElement('div');
    wrapper.id = 'js-av-pagination';
    wrapper.innerHTML =
      '<div class="pagination-wrapper">' +
        '<nav class="pagination" role="navigation" aria-label="ページネーション">' +
          '<ul class="pagination__list list-unstyled" role="list">' + li + '</ul>' +
        '</nav>' +
      '</div>';

    if (!existing) {
      var grid = document.getElementById('product-grid');
      if (grid && grid.parentNode) {
        grid.parentNode.appendChild(wrapper);
      }
    }

    wrapper.querySelectorAll('.js-av-page').forEach(function (btn) {
      btn.addEventListener('click', function () {
        showPage(parseInt(this.dataset.page, 10));
      });
    });
  }

  // ─────────────────────────────────────────────
  // Show page
  // ─────────────────────────────────────────────

  function showPage(pageNum) {
    var cfg = getConfig();
    if (!cfg || !sortedItems.length) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var perPage = cfg.perPage;
    var start = (pageNum - 1) * perPage;
    var batch = sortedItems.slice(start, start + perPage);

    isSorting = true;
    grid.innerHTML = '';
    batch.forEach(function (li, i) {
      li.style.setProperty('--animation-order', String(i + 1));
      grid.appendChild(li);
    });
    isSorting = false;

    renderPagination(sortedItems.length, pageNum, perPage);

    // Update URL without reloading
    var params = new URLSearchParams(window.location.search);
    if (pageNum === 1) {
      params.delete('page');
    } else {
      params.set('page', pageNum);
    }
    var newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    history.pushState({ avPage: pageNum }, '', newUrl);

    // Scroll to top of grid
    var gridTop = grid.getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top: gridTop, behavior: 'smooth' });
  }

  // ─────────────────────────────────────────────
  // Main sort entry point
  // ─────────────────────────────────────────────

  function runSort() {
    var cfg = getConfig();
    if (!cfg) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // When an explicit sort is applied, let Shopify handle the order natively
    if (new URLSearchParams(window.location.search).get('sort_by')) {
      grid.style.opacity = '';
      grid.style.transition = '';
      return;
    }

    // Single page: in-place DOM sort (fast, no network request)
    if (cfg.totalPages <= 1) {
      var items = Array.from(grid.querySelectorAll(':scope > li'));
      var availNew = items.filter(function (li) { return isAvailable(li) && isNew(li); });
      var availRest = items.filter(function (li) { return isAvailable(li) && !isNew(li); });
      var sold = items.filter(function (li) { return !isAvailable(li); });
      isSorting = true;
      availNew.concat(availRest).concat(sold).forEach(function (li) { grid.appendChild(li); });
      isSorting = false;
      // Restore visibility (may have been hidden by MutationObserver on sort/filter change)
      grid.style.transition = 'opacity 0.25s';
      requestAnimationFrame(function () {
        grid.style.opacity = '1';
        setTimeout(function () { grid.style.transition = ''; grid.style.opacity = ''; }, 300);
      });
      return;
    }

    // Multi-page: hide grid while fetching, then reveal sorted
    grid.style.opacity = '0';

    var reqId = ++sortRequestId;
    sortedItems = [];

    fetchAllItems(cfg).then(function (all) {
      if (reqId !== sortRequestId) return;

      var availNew = all.filter(function (li) { return isAvailable(li) && isNew(li); });
      var availRest = all.filter(function (li) { return isAvailable(li) && !isNew(li); });
      var soldOut = all.filter(function (li) { return !isAvailable(li); });
      sortedItems = availNew.concat(availRest).concat(soldOut);

      showPage(getCurrentUrlPage());

      // Fade in sorted products
      grid.style.transition = 'opacity 0.25s';
      requestAnimationFrame(function () {
        grid.style.opacity = '1';
        setTimeout(function () {
          grid.style.transition = '';
          grid.style.opacity = '';
        }, 300);
      });
    }).catch(function () {
      // On error, restore visibility
      grid.style.opacity = '';
    });
  }

  // ─────────────────────────────────────────────
  // Observe Dawn AJAX filter updates
  // ─────────────────────────────────────────────

  function startObserver() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // Dawn replaces #ProductGridContainer.innerHTML on each filter/sort change,
    // which triggers childList mutations on the container's direct children.
    var observer = new MutationObserver(function () {
      if (isSorting) return;
      clearTimeout(resortTimer);
      // Hide grid immediately so stale unsorted products aren't visible while re-fetching
      var grid = document.getElementById('product-grid');
      if (grid) grid.style.opacity = '0';
      resortTimer = setTimeout(function () {
        sortedItems = [];
        runSort();
      }, 150);
    });

    observer.observe(container, { childList: true, subtree: false });
  }

  // Browser back/forward
  window.addEventListener('popstate', function (e) {
    if (sortedItems.length && e.state && e.state.avPage) {
      showPage(e.state.avPage);
    }
  });

  // ─────────────────────────────────────────────
  // Init
  // ─────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runSort();
      startObserver();
    });
  } else {
    runSort();
    startObserver();
  }
})();
